import { render, staticRenderFns } from "./TermAndCond.vue?vue&type=template&id=5ece8be8&"
import script from "./TermAndCond.vue?vue&type=script&lang=js&"
export * from "./TermAndCond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports